import Highcharts from "highcharts";
import { formatStorageSize } from "utils/helpers";

export const tooltipFormatter = function (this: any) {
  return `
      <b>${Highcharts.dateFormat("%b %e", this.x!)}</b><br/>
      ${formatStorageSize(this.y!)}
    `;
};
